/* unplugin-vue-components disabled */import script from "./imgCropper.vue?vue&type=script&setup=true&lang=js"
export * from "./imgCropper.vue?vue&type=script&setup=true&lang=js"

import "./imgCropper.vue?vue&type=style&index=0&id=7f4016be&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4016be"]])

export default __exports__